import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLang } from '../contexts/LanguageContext';
import t from '../translations';

export default function ChartLoadingPage() {
  const navigate          = useNavigate();
  const { profile, refreshProfile } = useAuth();
  const { lang }          = useLang();
  const tr                = t[lang];
  const [dots, setDots]   = useState(0);
  const startTs           = React.useRef(Date.now());

  // Rotate dots animation
  useEffect(() => {
    const id = setInterval(() => setDots(d => (d + 1) % 4), 500);
    return () => clearInterval(id);
  }, []);

  // Poll until chart is in the profile, then navigate
  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      await refreshProfile();
      const elapsed = Date.now() - startTs.current;
      const minWait = 2000;

      if (cancelled) return;

      const delay = Math.max(0, minWait - elapsed);
      setTimeout(() => {
        if (!cancelled) navigate('/home', { replace: true });
      }, delay);
    };

    const timer = setTimeout(check, 1200);
    return () => { cancelled = true; clearTimeout(timer); };
  }, []);

  return (
    <div
      data-testid="chart-loading-page"
      style={{
        minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: '#0A0F1E', padding: 24, textAlign: 'center',
      }}
    >
      {/* Rotating mandala */}
      <div style={{ position: 'relative', marginBottom: 40 }}>
        <img
          src="https://static.prod-images.emergentagent.com/jobs/a18daceb-ae2c-4f94-b376-8eade8d6511f/images/fecd75b0b7001ec8bb23d55cb7dd749f25eee7eba8a99200062f858dbf83ba5e.png"
          alt="Mandala"
          className="rotate-mandala"
          style={{ width: 200, height: 200, objectFit: 'contain', opacity: 0.9 }}
          data-testid="mandala-animation"
          onError={e => { e.target.style.display = 'none'; }}
        />
        {/* Gold centre */}
        <div style={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%,-50%)',
          width: 12, height: 12, borderRadius: '50%',
          background: '#C9A84C',
          boxShadow: '0 0 20px rgba(201,168,76,0.8)',
        }} />
      </div>

      <p
        className="shimmer-text"
        style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 600 }}
      >
        {tr.readingStars}{'…'.slice(0, dots + 1)}
      </p>
      <p style={{ fontSize: 13, color: '#8A8580', marginTop: 10 }}>
        {tr.buildingChart}
      </p>

      <div style={{ display: 'flex', gap: 8, marginTop: 32 }}>
        {[0, 0.4, 0.8].map((d, i) => (
          <div
            key={i}
            style={{
              width: 6, height: 6, borderRadius: '50%', background: '#C9A84C',
              animation: `goldPulse 1.4s ease-in-out ${d}s infinite`,
              opacity: 0.8,
            }}
          />
        ))}
      </div>
    </div>
  );
}
